import React, { useState, FC } from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { isEmpty } from 'lodash';

interface EditActionsProps {
  menuItems: React.ReactNode[];
}

const EditActions: FC<EditActionsProps> = (props) => {
  const { menuItems } = props;
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const classes = useStyles();

  if (isEmpty(menuItems)) return <></>;

  return (
    <>
      <IconButton
        aria-label='more'
        aria-controls='actions-menu'
        aria-haspopup='true'
        onClick={handleMenuOpen}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='actions-menu'
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
      >
        {menuItems?.map((child, index) => (
          <MenuItem key={index} onClick={handleMenuClose} className={classes.menuItem}>
            {child}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const useStyles = makeStyles(() => ({
  menuItem: {
    '& > span': {
      width: '100%',
    },
    '& button': {
      width: 'calc(100% + 32px)',
      margin: '-6px -16px',
      padding: '10px',
      '& span': {
        justifyContent: 'start',
      },
    },
  },
}));

export default EditActions;
